import { Path } from 'slate';
import { isTextNode } from './isTextNode.mjs';
import { isElement } from '../utilities/nodes/elements/isElement.mjs';

function isDocumentElement(node) {
  return !isElement(node) && !isTextNode(node) && 'children' in node;
}
function isDocumentRoot(node, path) {
  return isDocumentElement(node) && Path.equals(path, [0]);
}

export { isDocumentElement, isDocumentRoot };
